<template>
  <div class="row">
    <div class="col-12">
      <div class="row d-flex justify-content-center">
        <div class="col-6 mt-2">
          <el-card
            shadow="always"
            class="p-0"
            style="border-radius: 10px"
            v-loading="loading"
          >
            <div class="row pb-4">
              <div class="col-12">
                <h2
                  class="text-navy text-uppercase mb-2 font-weight-bold text-center"
                >
                  ID Verification In Progress
                </h2>
              </div>
              <div class="col-12 text-center mt-2">
                <p>
                  Your ID verification is in progress. You will be notified once
                  it is completed.
                </p>
                <p>
                  If you cancelled the ID verification, please contact our
                  support team.
                </p>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},

  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
